module.exports = __webpack_public_path__ + "img/no-results-drawing.e148c064.png";